import { toast } from 'react-toastify';
import { useAutoContinueRunner } from './useAutoContinue';

const notify = (type, message) => {
  const show = toast[type] || toast;
  show(message);
};

// Layout darajasida (App.jsx) faqat admin va super_admin uchun render qilinadi. UI chiqarmaydi.
export default function AutoContinueRunner() {
  useAutoContinueRunner(notify);
  return null;
}
